import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {DhcpOption} from '../../Types/routerForms';
import {useAddOption, useRemoveOption} from '../../Hooks/RouterManager';
import AddDhcpOptionModal from './AddDhcpOptionModal';
import ActionIcon from '../../../../Components/ActionIcon';
import Level3Title from '../../../../app/common/components/title/Level3Title';

interface DhcpOptionsSectionProps {
  routerId: string;
  options: DhcpOption[];
}

const DhcpOptionsSection = ({routerId, options}: DhcpOptionsSectionProps): JSX.Element => {
  const intl = useIntl();
  const [showAdd, setShowAdd] = useState(false);
  const addOption = useAddOption(routerId);
  const removeOption = useRemoveOption(routerId);

  const handleDelete = (id: string) => {
    if (
      window.confirm(intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.CONFIRM_DELETE'}))
    ) {
      removeOption.mutate(id);
    }
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title
            title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.TITLE'})}
          />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <table className="table table-row-dashed align-middle">
          <thead>
            <tr className="fw-semibold text-muted">
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.NAME'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.CODE'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.VALUE'})}</th>
              <th style={{width: 60}}></th>
            </tr>
          </thead>
          <tbody>
            {options.length === 0 && (
              <tr>
                <td colSpan={4} className="text-muted text-center">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.EMPTY'})}
                </td>
              </tr>
            )}
            {options.map((o) => (
              <tr key={o.id}>
                <td>{o.name}</td>
                <td>{o.code}</td>
                <td>{o.value}</td>
                <td>
                  <ActionIcon
                    label={intl.formatMessage({id: 'COMMON.DELETE'})}
                    faIcon="fa-solid fa-trash text-danger"
                    onClick={() => handleDelete(o.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="btn btn-light btn-sm" onClick={() => setShowAdd(true)}>
          <i className="fa-solid fa-plus me-2" />
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.OPTIONS.ADD'})}
        </button>
        <AddDhcpOptionModal
          show={showAdd}
          onHide={() => setShowAdd(false)}
          onAdd={(o) => addOption.mutate({name: o.name, code: o.code, value: o.value})}
        />
      </Card.Body>
    </Card>
  );
};

export default DhcpOptionsSection;
